document.addEventListener("turbolinks:load", function () {
    // Only run this code on the sign in page
    if (!document.querySelector("#sign-in-page")) {
        return;
    }

    // Ensures the sign in form's CSRF token properly refreshes after page navigation - e.g. changing languages
    Rails.refreshCSRFTokens();

    // Function to set help icon in header bar responsively
    let screenSize = window.screen.width;
    const desktopScreen = (w) => (w > 820);

    // Function for the capslock indicator and show password indicators
    const checkCapsLock = (e) => {
        let safariAgent = navigator.userAgent.indexOf("Safari") > 1;
        let chromeAgent = navigator.userAgent.indexOf("Chrome") > 1;
        if (safariAgent && !chromeAgent) {
            return
        } else if (!desktopScreen(screenSize)) {
            let capsLockOn = e.getModifierState("CapsLock");
            capsLockImage.src = (capsLockOn ? "" : "");
            return capsLockImage.src;
        } else {
            let capsLockOn = e.getModifierState("CapsLock");
            let capsLockImage = document.querySelector(".password-capslock");
            capsLockImage.src = (capsLockOn ? capsLockImage.dataset.capslockIcon : "");
            capsLockImage.alt = (capsLockOn ? "Caps Lock On" : "")
            return capsLockImage.src;
        }
    }
    const password = document.querySelector("#password_field");
    // Prevents the capslock indicator from displaying on mobile
    // Pressing the capslock key only fires the "keydown" event when turning capslock on
    // Disable VB caps lock indicator functionality for iOS browsers
    password.addEventListener("keydown", checkCapsLock);
    // Pressing the capslock key only fires the "keyup" event when turning capslock off
    password.addEventListener("keyup", checkCapsLock);
    password.addEventListener("mousedown", checkCapsLock);

    // Function for toggling the show/hide password functionality
    const toggleShowPassword = () => {
        let passwordField = document.querySelector("#password_field");
        let passwordIndicator = document.querySelector(".password-indicator");
        if (passwordField.getAttribute("type") === "password") {
            passwordField.setAttribute("type", "text");
            passwordIndicator.src = passwordIndicator.dataset.hideIcon;
            passwordIndicator.alt = "Hide Password"
        } else {
            passwordField.setAttribute("type", "password");
            passwordIndicator.src = passwordIndicator.dataset.showIcon;
            passwordIndicator.alt = "Show Password"
        }
    }
    // Turbolinks can assign the same event handler multiple times
    // Using "onclick" and "onkeyup" first removes existing event handler
    document.querySelector("#show_password").onclick = toggleShowPassword;
    document.querySelector("#show_password").onkeyup = function (e) {
        if (e.key === "Enter") toggleShowPassword();
    }

    // Puts focus on password input field when clicking in password box on desktop
    document.querySelector(".sso-input-group").addEventListener("click", () => {
        document.querySelector("#password_field").focus();
    });

    // Sets up the forgot password modal
    const forgotPasswordModal = document.querySelector(".forgot-password-modal");
    if (forgotPasswordModal) {
        setUpModal(undefined, ".forgot-password-modal");
        openModal(".forgot-password-modal");
    }

    const studentPreviewEnabled = document.getElementById("student_preview_enabled");
    const signInButton = document.querySelector(".btn-sso-signin");
    const googleSignInButton = document.querySelector(".btn-sso-google");
    const emailField = document.getElementById("user_email");
    const passwordField = document.getElementById("password_field");
    const forgotPassword = document.getElementById("forgot-password");
    const adoptionSignUpLink = document.getElementById("adoption-sign-up-link");
    const siteLicenseSignUpLink = document.getElementById("site-license-sign-up-link");
    const showPassword = document.getElementById("show_password");

    if (studentPreviewEnabled.value === "true") {
        if (signInButton) signInButton.disabled = true;
        if (googleSignInButton) googleSignInButton.disabled = true;
        if (emailField) emailField.disabled = true;
        if (passwordField) passwordField.disabled = true;
        if (showPassword) showPassword.style.display = "none";
        if (forgotPassword) forgotPassword.style.display = "none";
        if (adoptionSignUpLink) adoptionSignUpLink.style.display = "none";
        if (siteLicenseSignUpLink) siteLicenseSignUpLink.style.display = "none";
    }
})